import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
export function Hero() {
  return <section className="relative h-screen w-full flex items-center justify-center overflow-hidden" data-id="element-118">
      <div className="absolute inset-0 z-0" data-id="element-119">
        <motion.img src="https://cdn.magicpatterns.com/uploads/usZogFJoDnYGKVJE9NX38g/Onyx__Steel_Banner.png" alt="Barbershop Banner" className="w-full h-full object-cover" initial={{
        scale: 1.1
      }} animate={{
        scale: 1
      }} transition={{
        duration: 10,
        ease: 'easeOut'
      }} data-id="element-120" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/40 to-[#1A1A1B]" data-id="element-121"></div>
      </div>

      <div className="relative z-10 container mx-auto px-6 flex flex-col items-center text-center mt-20" data-id="element-122">
        <motion.h1 className="font-serif text-5xl md:text-7xl lg:text-8xl tracking-[0.15em] mb-6 text-white" initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.2,
        ease: 'easeOut'
      }} data-id="element-123">
          ONYX & STEEL
        </motion.h1>
        <motion.p className="text-lg md:text-xl text-white/80 font-light tracking-[0.2em] uppercase mb-12 max-w-2xl" initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.4,
        ease: 'easeOut'
      }} data-id="element-124">
          Where Precision Becomes Confidence
        </motion.p>
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.6,
        ease: 'easeOut'
      }} data-id="element-125">
          <Button data-id="element-126">Book Your Experience</Button>
        </motion.div>
      </div>
    </section>;
}